import React, { useEffect, useState } from "react";
import { History } from "../api";
import PageDirector from "../container/PageDirector";
import { useGlobal } from "../global/user";
import { Table, Input, Button } from "antd";
import { CSVLink } from "react-csv";
import FieldSelect from "../container/SelectField";
import Header from "../container/Header";
export default function HistoryPage() {
  const { fields, setFields, field } = useGlobal();
  const [rawData, setRawData] = useState([]);
  const [data, setData] = useState([]);
  const [machines, setMachines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [keyword, setKeyWord] = useState("");
  const [CSV_NAME, setCSV_NAME] = useState("");
  useEffect(async () => {
    if (field === -1) {
      setLoading(false);
      return;
    }
    setLoading(true);
    const NewField = fields.find((x) => x.field_id === parseInt(field, 10));
    setCSV_NAME(NewField.field_name);
    let response = await History.GetHisoryData(NewField.field_id);
    setRawData(response.data);

    setData(
      response.data.map((row, index) => {
        const time = new Date(row.time);
        row.time = time.getTime() - 1000 * 60 * 60 * 8; // this accounts for timezone offset
        return {
          ...row,
          key: row.id || index, // 使用 id 作為 key，如果沒有 id 則使用 index
        };
      })
    );
    setMachines([...new Set(response.data.map((m) => m.name))]);
    setLoading(false);
  }, [fields, field]);
  const columns = [
    {
      title: "機具",
      dataIndex: "name",
      key: "name",
      filters: machines.map((name) => ({ text: name, value: name })),
      onFilter: (value, record) => record.name === value,
      sorter: (a, b) => (a.name > b.name ? -1 : a.name < b.name ? 1 : 0),
      fixed: "left",
      width: 110,
    },
    {
      title: "操作使用者",
      dataIndex: "executer",
      key: "executer",
      filters: [...new Set(data.map((m) => m.executer))].map((user) => ({
        text: user,
        value: user,
      })),
      onFilter: (value, record) => record.executer === value,
      sorter: (a, b) => (a.executer > b.executer ? -1 : a.executer < b.executer ? 1 : 0),
      width: 200,
    },
    {
      title: "內容",
      dataIndex: "record",
      key: "record",
      sorter: (a, b) => (a.record > b.record ? -1 : a.record < b.record ? 1 : 0),
    },
    {
      title: "紀錄時間",
      dataIndex: "time",
      key: "time",
      defaultSortOrder: "descend",
      render: (text) => new Date(text).toLocaleString(),
      sorter: (a, b) => new Date(a.time) - new Date(b.time),
    },
  ];
  console.log(rawData);
  return (
    <React.Fragment>
      <Header />
      <div className="container-fluid">
        <div className="page-container fade-in">
          <PageDirector setFields={setFields} />
          <FieldSelect />

          <div className="button-group-right">
            <Input 
              className="search-input" 
              placeholder="輸入關鍵字" 
              onChange={(e) => setKeyWord(e.target.value)} 
            />
            <Button
              type="default"
              onClick={() => {
                if (keyword.length === 0) {
                  setData(rawData);
                  return;
                }
                setData(
                  rawData.filter((line) => {
                    if (line.record.search(keyword) !== -1) return true;
                    if (line.name.search(keyword) !== -1) return true;
                    if (line.executer.search(keyword) !== -1) return true;
                    if (new Date(line.time).toLocaleString().search(keyword) !== -1) return true;
                    return false;
                  })
                );
              }}
              style={{
                background: "var(--content-background)",
                color: "var(--primary-text)",
                border: "2px solid var(--primary-border)"
              }}
            >
              查詢
            </Button>
            <CSVLink
              data={rawData.map((oldData) => {
                const newData = { ...oldData };
                newData.time = new Date(oldData.time).toLocaleString();
                return newData;
              })}
              filename={CSV_NAME + "歷史資訊.csv"}
            >
              <Button
                style={{
                  background: "var(--content-background)",
                  color: "var(--primary-text)",
                  border: "2px solid var(--primary-border)"
                }}
              >
                下載
              </Button>
            </CSVLink>
          </div>
          <div className="card-container">
            <Table
              scroll={{ x: 900 }}
              dataSource={data}
              columns={columns}
              loading={loading}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["10", "25", "50", "100"],
                showQuickJumper: true,
                showTotal: (total) => `總共 ${total} 筆資料`,
                responsive: true,
              }}
              bordered
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
